import iframePlugin from './iframePlugin';
import htmlTemplatePlugin from './htmlTemplatePlugin';
import emailPlugin from './emailPlugin';
import commentsPlugin from './commentsPlugin';
import plugins from 'taskboard-plugins';
// import config from '../../config';

let _plugins = [iframePlugin, htmlTemplatePlugin, plugins.FormPlugin, emailPlugin, commentsPlugin];
// if (config.env !== 'prod') {
//     _plugins.push()
// }

export default {

    getAvailablePlugins: function() {
        return _plugins.slice();
    },

    getPluginByTypeId(pluginTypeId) {
        return _plugins.find(plugin => plugin.pluginTypeId === pluginTypeId);
    }

}



// WEBPACK FOOTER //
// ./src/components/plugins/PluginsManager.js